// extracted by mini-css-extract-plugin
export var activeLink = "NewHeader-module--activeLink--GdMJR";
export var contactBtn = "NewHeader-module--contactBtn--EDMYF";
export var ctaButtons = "NewHeader-module--ctaButtons--FTuzL";
export var enrollBtn = "NewHeader-module--enrollBtn--tcocT";
export var enrollIcon = "NewHeader-module--enrollIcon--1QXIO";
export var headerWrapper = "NewHeader-module--headerWrapper--5HayV";
export var logoImage = "NewHeader-module--logoImage--y0YTm";
export var menuButton = "NewHeader-module--menuButton--tn4Gp";
export var mobileMenuWrapper = "NewHeader-module--mobileMenuWrapper--+58Qe";
export var navBar = "NewHeader-module--navBar--ugwYA";
export var navBarList = "NewHeader-module--navBarList--U6khB";
export var navbarContainer = "NewHeader-module--navbarContainer--1Nd5W";